import { get, post } from "./http";
export const nav = p => post("/api/index/nav", p);
export const banner = p => post("/api/index/banner", p);
export const partner = p => post("/api/index/partner", p);
export const solutionList = p => post("/api/solution/list", p);
export const solutionInfo = p => post("/api/solution/info", p);
export const newsList = p => post("/api/news/list", p);
export const newsInfo = p => post("/api/news/info", p);
export const serviceList = p => post("/api/service/list", p);
export const divisionMenu = p => post("/api/division/menu", p);
export const divisionList = p => post("/api/division/list", p);
export const divisionInfo = p => post("/api/division/info", p);
export const divisionOther = p => post("/api/division/other", p);
export const serviceCate = p => post("/api/service/cate", p);
export const aboutCate = p => post("/api/about/cate", p);
export const aboutList = p => post("/api/about/list", p);
export const aboutContact = p => post("/api/about/contact", p);
export const company = p => post("/api/index/company", p);
export const support = p => post("/api/index/support", p);
export const navInfo = p => post("/api/index/getNavInfo", p);



// WEBPACK FOOTER //
// ./src/request/api.js